import React from 'react';
import PropTypes from 'prop-types';

import SwitchControl from './SwitchControl';
import SwitchWithLabel from './SwitchWithLabel';

const Switch = ({
  label,
  ...rest
}) => {
  if (label) {
    return (
      <SwitchWithLabel
        label={label}
        {...rest}
      />
    );
  }

  return (
    <SwitchControl
      {...rest}
    />
  );
};

Switch.defaultProps = {
  label: null,
};

Switch.propTypes = {
  label: PropTypes.string,
};

export default Switch;
